import { configureStore } from '@reduxjs/toolkit';
import filtersReducer from './filters';
import contentReducer from './content';
import modeReducer from './mode';
import dataReducer from './data';
import {
  dataSecondLvlReducer,
  filtersSecondLvlReducer,
  modeSecondLvlReducer,
} from './secondLevel';

const store = configureStore({
  reducer: {
    filters: filtersReducer,
    content: contentReducer,
    data: dataReducer,
    mode: modeReducer,
    filtersSecondLvl: filtersSecondLvlReducer,
    modeSecondLvl: modeSecondLvlReducer,
    dataSecondLvl: dataSecondLvlReducer,
  },
});

export default store;
